import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import {
		computed
	} from 'vue'

	// router
	import {
		useRoute
	} from 'vue-router'
	
	import MainLayout from './layouts/MainLayout.vue'

	
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// vue
	const isLoaded = true

	const route = useRoute()
	const layout = computed(() => {
		return route.meta.layout || MainLayout
	})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return isLoaded
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layout)), { key: 0 }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _unref(route).fullPath
          }))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})